import { Directive, ElementRef, HostListener, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NgControl } from '@angular/forms';
import { NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[ignoreWhiteSpace]',
  host: {
      '(focus)': 'onFocus($event)',
      '(blur)': 'onBlur($event)',
      '(keyup)': 'onInput($event)',
      '(keydown)': 'onInput($event)',
      '(input)':  'onInput($event)'
  }
})

export class IgnoreWhiteSpaceDirective {
  private validators: any;
  private asyncValidators: any;
  private wasChanged: any;

  constructor(public formControl: NgControl) { }

  onFocus($event) {
      this.wasChanged = false;
      this.validators = this.formControl.control.validator;
      this.asyncValidators = this.formControl.control.asyncValidator;
      this.formControl.control.clearAsyncValidators();
      this.formControl.control.clearValidators();
  }
  
  onInput($event) {
      this.formControl.control.setValue(this.formControl.control.value?.toString().replace(/\s/g, ''));
      this.wasChanged = true; // keyboard change
  }

  onBlur($event) {
      this.formControl.control.setValue(this.formControl.control.value?.toString().replace(/\s/g, ''));
      this.formControl.control.setAsyncValidators(this.asyncValidators);
      this.formControl.control.setValidators(this.validators);
      if (this.wasChanged)
          this.formControl.control.updateValueAndValidity();
  }
}